import angular from 'angular'
import env from '../../../config/environment'
import { setLocalStorageItem, getLocalStorageItem } from '../../../utils/helpers'

class UsuariosService {
    static get $inject() {
        return ['$http', 'gql']
    }

    constructor($http, gql) {
        this.$http = $http
        this.gql = gql
    }

    async login(email, password) {
        delete this.$http.defaults.headers.common.authorization
        delete this.$http.defaults.headers.post.authorization
        const { data: { usuario, token } } = await this.$http.post(env.api_url + '/login', { login: { email, password } })
        const { data: { data: { phpsession, token: legacyToken } } } = await this._loginLegacy(token)

        setLocalStorageItem(env.jwt_token, token)
        setLocalStorageItem(env.api_token, legacyToken)
        setLocalStorageItem(env.ef_usuario, usuario)
        setLocalStorageItem(env.ef_phpsession, phpsession)

        this.usuario = usuario
        this.jwt = token
        this.phpsession = phpsession
        this.legacyToken = legacyToken

        return { usuario, token, legacyToken }
    }

    async logout() {
        const headers = { 'Authorization': this.jwt, 'x-ef-token': this.legacyToken }

        await this.$http
            .post(env.api_url + `/user/logout`, {}, { headers, withCredentials: true })
            .catch(console.error)

        this.usuario = null
        this.jwt = null
        this.phpsession = null
        this.legacyToken = null

        localStorage.removeItem(env.jwt_token)
        localStorage.removeItem(env.api_token)
        localStorage.removeItem(env.ef_usuario)
        localStorage.removeItem(env.ef_phpsession)
        sessionStorage.clear()
    }

    resetPassword(email) {
        return this.$http.post(env.api_url + '/usuarios/password-reset', { email })
    }

    confirmarResetPassword(token) {
        return this.$http.get(env.api_url + `/usuarios/password-reset/${token}`)
    }

    confirmarCadastro(token) {
        return this.$http
            .get(env.api_url + `/usuarios/confirmar/${token}`)
            .then(({ data: { usuario } }) => usuario)
    }

    authorizeAplicacao(email, senha, token) {
        const mutation = gql`
        mutation AuthorizeAplicacao($email: String!, $senha: String!, $token: String!) {
            usuario:authorizeAplicacao(email: $email, senha: $senha, token: $token) {
                id
            }
        }
        `

        return this.gql
            .mutate(mutation, { email, senha, token })
            .then(({ usuario }) => usuario)
    }

    permissoes(filter = {}) {
        const query = gql`
            query UsuarioFerramentasContratadas($filter: PermissaoFilter) {
                usuarioAtual {
                    id
                    permissoes(filter: $filter) {
                        id
                        filiais {
                            ferramentasContratadas
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query, { filter })
            .then(({ usuarioAtual: { permissoes } }) => permissoes.flatMap(p => p.filiais))
            .then(filiais => filiais.flatMap(({ ferramentasContratadas }) => ferramentasContratadas).uniq())
    }

    get usuarioLogado() {
        if (this.usuario) return this.usuario

        this.usuario = getLocalStorageItem(env.ef_usuario)

        return this.usuario
    }

    get token() {
        if (this.jwt) return this.jwt

        this.jwt = getLocalStorageItem(env.jwt_token)

        return this.jwt
    }

    _loginLegacy(jwt) {
        return this.$http.post(env.api_url + '/user/login', { jwt }, { withCredentials: true })
    }
}

angular.module('eficienciaFiscalModule').service('UsuariosService', UsuariosService)
